import Vue from 'vue'
import commonDialog from '@/components/commonDialog.vue'

export default {
  /* 本来は、ここに共通初期化処理として、created()関数を設けようとしたが、
   * グローバルミックスインされたcreatedは、Vueインスタンスの数だけ関数が走る為、
   * getUrlParamはcreatedに書かず、App.vueのmounted時に呼び出すようにしました。
   */

  // 共通関数宣言場所
  methods: {
    /**
     * URLパラメータを取得し、localStorageに保存する共通関数(重複keyは後の値で上書きになる)
     * （注：App.vueのmountedにて、画面表示時、自動呼出処理化しています）
     */
    getUrlParam() {
      var queryString = location.search;
      if (queryString) {
        var urlParam = [...new URLSearchParams(queryString).entries()].reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
        this.storageSave(JSON.stringify(urlParam));
      }
    },

    /**
     * URLパラメータの値を取得する
     * （注：App.vueのmountedにて、画面表示時、自動呼出処理化しています）
     */
    getUrlGetParam(key) {
      var queryString = location.search;
      if (queryString) {
        var urlParam = [...new URLSearchParams(queryString).entries()].reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
          return urlParam[key]
      }
    },

    /**
     * ネイティブ側へ値や信号を送る関数。引数ObjectをJSONstringに変換して送り出す。
     * （注：ネイティブ側から叩けるようにする為には、App.vueのmountedにグローバル化する登録が必要）
     * @param {object} obj オブジェクト形式の送信値。
     */
    nativePost(obj) {
      /*
       * 以下ネイティブ側との設定用key名とvalue値の仕様（ネイティブ側の動作を指定できる）
       * obj内に「_vue_param: "true"」設定すると → アラートを出さず、特定のキーで遷移処理などをしてくれる。
       * obj内に「_vue_param: "true" _alert: "テスト"」設定 → 「テスト」文字の埋め込まれた、ネイティブ側のアラートを出してくれる。
       * obj内に、特定key名の設定無し → alert関数動作のまま、webviewアラートをそのまま出してくれる。
       */
      var previewflg = this.getUrlGetParam('preview');

      if(previewflg != 1){
        var jsonString = JSON.stringify(obj);
        alert(jsonString);
      }
    },

    /**
    * 【試験実装】ネイティブ側からVue側へ、遷移前ページを履歴に残さず、urlリダイレクト命令を出す関数
    * （注：ネイティブ側から叩けるようにする為には、App.vueのmountedにグローバル化する登録が必要）
    * @param {string} url リダイレクト先URLの指定。
    */
    nativeRedirect(url) {
      if (url) {
        location.replace(url);
        return true;
      }
      return false;
    },

    /**
     * 引数に設定されたデータを、重複したキー名のみ上書きしつつ、localStorageに保存する関数。
     * @param {string} jsonString jsonString形式の保存したい値。
     */
    storageSave(jsonString) {
      try {
        if (localStorage.storageData) {
          // 既にstorageDataがある場合は、旧データと新データをObjectに変換・マージしたJsonStringを生成。
          var oldObjData = JSON.parse(localStorage.storageData);
          var newObjData = JSON.parse(jsonString);
          jsonString = JSON.stringify(Object.assign(oldObjData, newObjData)); //キー名重複は上書き
        }

        // ローカルストレージはobjを保存できないので、jsonStringのまま保存。
        localStorage.storageData = jsonString;
        //console.log("Save Storage:" + localStorage.storageData);
        return true
      } catch {
        //console.log("Error Save Storage:" + jsonString);
        return false
      }
    },

    /**
     * 保存したlocalStorageのデータをobjに変換して、特定key値を取得する関数。
     * @param {string} key 取得するkey値の指定。'*'指定で全データをobject形式で取得。
     */
    storageGet(key) {
      if (localStorage.storageData) {
        var obj = JSON.parse(localStorage.storageData);
        if (key == '*') {
          // 引数keyに*文字を使うと、obj自体を全て取得
          //console.log(obj);
          return obj ? obj : false;
        } else {
          // それ以外は指定キーのvalueを取得
          //console.log(obj[key]);
          return obj[key] ? obj[key] : false;
        }
      }
      return false;
    },

    /**
     * 保存したlocalStorageのデータから、特定key値を削除する関数。（削除成功時return true）
     * @param {string} key 削除するkey値の指定。'*'指定でlocalStorage自体を削除(全削除)。
     */
    storageDelete(key) {
      if (localStorage.storageData) {
        var obj = JSON.parse(localStorage.storageData);
        if (key == '*') {
          // localStorage自体を削除
          localStorage.removeItem('storageData');
          //console.log('delete storage !!');
          return localStorage.storageData ? false : true;
        } else {
          // それ以外は指定キーのvalueを削除し、localStorageを更新。
          delete obj[key];
          localStorage.storageData = JSON.stringify(obj);
          //console.log(obj[key]);
          //console.log(key + 'delete storage !!');
          return obj[key] ? false : true;
        }
      }
      return false;
    },

    /**
     * APIを叩く関数。
     * @param {string} url baseURLの続きに当たる、相対パスURL。
     * @param {object} request オブジェクト形式のリクエストパラメーター。
     * @param {string} type get/post/delete、APIのメソッドタイプを文字列で指定（axiosに左記以外の種類があるかは不明）
     * @param {number} host hostUrlに事前登録しておいた別ホストへ、APIの叩き先を指定（事前登録すれば、複数URL先登録可）
     */
    apiCall(url, request, type = 'get', host = 0, error_title = 'エラー') {
      let access_token = null
      let refresh_token = null
      let settlement_token = null
      if(this.storageGet('access_token')){
        access_token = this.storageGet('access_token')
      }
      if(this.storageGet('refresh_token')){
        refresh_token = this.storageGet('refresh_token')
      }
      if(this.storageGet('settlement_token')){
        settlement_token = this.storageGet('settlement_token')
      }
      //console.log(request)

      const hostUrl = {
        0: process.env.VUE_APP_API_URL_BASE, //開発フロント側API(デフォルト先)
        1: process.env.VUE_APP_API_URL_STUB, //スタブAPI
        2: process.env.VUE_APP_API_URL_AUTH, //認証サーバ
        3: process.env.VUE_APP_API_URL_PAYMENT, //決済サーバ
      }
      const axiosBase = require('axios');

      //本番では以下BASIC認証については不要となります
      /*
      const clientId = "uplink";
      const clientSecret = "usen-cc";
      //Basic認証のために、base64でエンコードする
      const encodedData = Buffer.from(clientId + ":" + clientSecret).toString(
        "base64"
      );
      */
      const axios = axiosBase.create({
        baseURL: hostUrl[host],
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
          'Access-Control-Allow-Headers': 'Access-Control-Allow-Origin, Origin, Content-Type, Accept, Referer, Content-Length, X-Requested-With, Access-Token, Refresh-Token, Settlement-Token',
          'Access-Control-Allow-Credentials': true,
          'Access-Token': access_token,
          'Refresh-Token': refresh_token,
          'Settlement-Token': settlement_token,
          //'Authorization': "Basic " + encodedData,
        },
        responseType: 'json',
        timeout : 100000,
      });

      // 必須パラメーターセット
      if (host == 0) {
        if (type == 'get') {
          request.params = this.setApiIndispensableParams(request.params);
        } else {
          request = this.setApiIndispensableParams(request);
        }
      }

      var res_data = axios[type](url, request).then(response => {
        // トークンの更新があれば保存
        this.tokenUpdate(response);
        // API通信そのものの成功時の処理。
        switch (response.data.status) {
          // status異常値の場合
          case 101: this.callDialog(error_title, response.data.message, 1); return false;
          case 102: this.callDialog(error_title, response.data.message, 1); return false;
          case 103: this.callDialog(error_title, response.data.message, 1); return false;
          case 104: this.callDialog(error_title, response.data.message, 1); return false;
          case 201: this.callDialog(error_title, response.data.message, 1); return false;
          case 202: this.callDialog(error_title, response.data.message, 1); return false;
          case 401: //401 Unauthorized tokenが切れた場合、ネイティブにアラートを送りログイン画面に遷移させる
              var lost_token_alert_req = {
                status: 701,
                destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/login/index",
                transition_type: 2
              }
              this.screenTransition(lost_token_alert_req)
              break;
          case 402: this.callDialog(error_title, response.data.message, 1); return false;
          case 404: this.callDialog(error_title, 'API システムエラー: ['+response.data.status+'] ['+host+']', 1); return false;
          case 500: this.callDialog(error_title, response.data.message, 1); return false;
          case 501: this.callDialog(error_title, response.data.message, 1); return false;
          case 701: //ログインエラーの場合、ネイティブにアラートを送りログイン画面に遷移させる
              var login_error_alert_req = {
                status: 701,
                destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/login/index",
                transition_type: 2
              }
              this.screenTransition(login_error_alert_req)
              break;
          case 703: this.callDialog(error_title, response.data.message + "。時間をおいて再試行をお願いいたします。", 1); this.loading = false; return false;
          case 707: //トークンエラーの場合、ネイティブにアラートを送りログイン画面に遷移させる
              var auth_error_alert_req = {
                status: 701,
                destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/login/index",
                transition_type: 2
              }
              this.screenTransition(auth_error_alert_req)
              break;
          case 901: this.callDialog(error_title, response.data.message, 1); return false;
          // 902,903,911,912はpoint-externalにて使用、メッセージは表示するがresponse.dataは必要なためreturn falseは行わない。
          case 902: this.callDialog(error_title, response.data.message, 1); break;
          case 903: break; //903はメッセージを表示しない。API側で番号を取得しているためcaseに含める。
          case 911: this.callDialog(error_title, response.data.message, 1); break;
          case 912: this.callDialog(error_title, response.data.message, 1); break;
          // 913はpoint-external/csdelight-registにて使用、902,903,911,912とはreturnが異なるため使用時は注意。
          case 913: this.callDialog(error_title, response.data.message, 1); return false;
          // 914はpoint-external/ldx-show、purchase-external/ldx-list、purchase-external/ldx-detail、/user/profile、/user/profile/updateにて使用
          case 914: this.callDialog(error_title, response.data.message, 1); return false;
          case 999: this.callDialog(error_title, response.data.message, 1); return false;
          default: break;
        }

        return response.data;
      }).catch(err => {
        error_title = error_title == 'エラー' ? '通信エラー' : error_title;
        // API通信そのもののエラー時の処理。
        switch (err.response.status) {
          case 401: //401 Unauthorized tokenが切れた場合、ネイティブにアラートを送りログイン画面に遷移させる
              var lost_token_alert_req = {
                status: 701,
                destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/login/index",
                transition_type: 2
              }
              this.screenTransition(lost_token_alert_req)
              break;
          case 701: //ログインエラーの場合、ネイティブにアラートを送りログイン画面に遷移させる
              var login_error_alert_req = {
                status: 701,
                destination: 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/login/index",
                transition_type: 2
              }
              this.screenTransition(login_error_alert_req)
              break;
          case 500:
          case 404:
            this.callDialog(error_title, 'API システムエラー: ['+err.response.status+'] ['+host+']', 1);
            break;
          default:
            this.callDialog(error_title, '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください['+err.response.status+']', 1);
            break;
        }
        return false;
      });

      return res_data;
    },

    /**
     * 共通ダイアログを表示する共通関数
     * @param {string} title ダイアログのタイトル文字
     * @param {string} message ダイアログの本文文字
     * @param {number} type ダイアログの表示タイプを指定。1は閉じるボタン。2は再アクセスボタン(APIエラーである事を考慮した)
     *
     */
    //20210121 NEW_DEV-768 cyber 李 start
    callDialog(title, message, type, id = null, history_id = null) {
      // 共通ダイアログ読み込み、表示
      var CD = Vue.extend(commonDialog);
      new CD ({
        parent: this,
        propsData: {
          title: title,
          message: message,
          type: type,
          id: id,
          history_id: history_id,
          //20210121 NEW_DEV-768 cyber 李 end
        },
      });
    },

    /**
     * routerlinkで遷移させる共通関数
     * @param {string} url 遷移先urlの指定（指定しないと現在の画面をリロードになる）
     */
    toLink(url = this.$router.currentRoute.path) {
      location.href = url;
      // this.$router.push(url);での遷移の場合、urlを絶対パスで指定できない為。
      // (URL末尾に指定パスがくっつき重複する。上記なら、絶対パスでも相対パスでも遷移可能)
    },

    /**
     * routerlinkで遷移させる共通関数
     * @param {string} url 遷移先urlの指定（指定しないと現在の画面をリロードになる）
     */
    routerBindTo(param) {
      this.$router.push(param);
    },

    /**
     * 戻るボタン操作共通関数
     * 戻り先がない場合はトップへ移動
     * @param {string} routeName
     * @param {object} params
     * @param {bool} back
    */
    routerBack(routeName = null, params = null, back = true) {
      // パス指定があっても戻り先が登録されていれば優先する
      if (window.history.length > 1 && back) {
        this.$router.go(-1);
      } else if (routeName || params) {
        let routeParam = {name: routeName};
        if (params) {
          routeParam.query = params;
        }
        this.routerBindTo(routeParam);
      } else {
        // トップへ
        let init = this.storageGet('*');
        if (init && init.menu_data && init.menu_data.menus) {
          let topName = init.menu_data.menus[0].screen_id.replace('_', '');
          this.$router.push({'name': topName});
        }
      }
    },

    /**
     * URL文字列のドメインまで取得する関数
     * @param
     */
    getDomain() {
      var href = location.href;
      return href.match('http[s]?://[^/]+/');
    },

    /**
     * URL文字列のパス部分を取得する関数
     * @param {string} url 遷移先url
     */
    getPath(url) {
      var domain = url.match('http[s]?://[^/]+');
      return url.replace(domain, '');
    },

    /**
     * routerlinkでリロードさせる関数
     */
    reload() {
      this.$router.go({path: this.$router.currentRoute.path, force: true});
    },
    /**
     * 遷移処理をまとめた共通関数。（遷移失敗時はreturn false)
     * （下記apiResponseは、ルーティングAPIのレスポンス値を使用しても良いし、下記4種のキー名で遷移情報を捏造したobjectデータも使用可能）
     * @param {object} apiResponse 遷移に必要な情報(feature_id, screen_id, transition_type, destination)を含むobject
     */
    screenTransition(apiResponse) {

      // ページタイトルがない場合は、メニュー情報から取得する
      if (!apiResponse.page_title && apiResponse.feature_id) {
          var menu = this.storageGet('menu_data')
          menu = menu['all_menus']
          menu.forEach( item => {
            if (item.feature_id == apiResponse.feature_id) {
              apiResponse.page_title = item.title
            }
          });
      }

      //console.log('apiResponse', apiResponse)

      switch (apiResponse.transition_type) {
        case 1:
          if (apiResponse.destination) {
            /*
            const str = 'https://test.com/top';
            const words = str.split('/');
            console.log(words[words.length-1]);
            */
            this.toLink(apiResponse.destination);
          } else {
            return false;
          }
          break;
        case 2:
          // nativePostへ信号、key['_vue_param']設定し、ネイティブ遷移の動作をするようネイティブ側に指示する。
          apiResponse['_vue_param'] = true;
          this.nativePost(apiResponse);
          break;
        case 3:
        case 4:
          // nativePostへ信号、key['_vue_param']設定し、外部URLを表示するようにする。
          apiResponse['_vue_param'] = true;
          this.nativePost(apiResponse);
          break;
        case 5:
          // 20201105 外部リンク追加対応 cyber 段 start
          // nativePostへ信号、key['_vue_param']設定し、外部URLを表示するようにする。
          apiResponse['_vue_param'] = true;
          this.nativePost(apiResponse);
          break;
          // 20201105 外部リンク追加対応 cyber 段 end
        default:
          return false;
      }
      return true;
    },
    /**
     * API実行に必須なパラメーターがなければセット
     * @param obj params
     * @return obj params
     */
    setApiIndispensableParams(params) {
      let tmp = ['sid', 'key', 'device_uid', 'device_id', 'os'];
      let info = this.storageGet('*');

      for (let key in info) {
        if (!params[key] && tmp.indexOf(key) !== -1) {
          params[key] = info[key];
        }
      }

      //プレビューパラメータがあった場合
      if(this.$route.query.preview == 1 && location.hostname == process.env.VUE_APP_HOST_NAME){
        params['preview'] = 1
      }
      return params;
    },
    /**
     * スクロール位置トップへ移動
     * @return void
     */
    scrollMoveTop() {
      if (window.scrollY > 0) {
        Vue.prototype.$scrollToTop = window.scrollTo(0,0);
      }
    },
    /**
     * トークン更新
     * @param  {[type]} res
     * @return {[type]}
     */
    tokenUpdate(res) {
      if (this.storageGet('bkup_refresh_token') && this.storageGet('bkup_refresh_token') == res.data['Refresh-Token']) {
        return;
      }
      // 更新された場合のみ保存
      if (res.data['Refresh-Token'] != null && this.storageGet('refresh_token') != res.data['Refresh-Token']) {
        this.storageSave(JSON.stringify({
          'access_token': res.data['Access-Token'],
          'refresh_token': res.data['Refresh-Token'],
          'bkup_refresh_token': this.storageGet('refresh_token')
        }))
      }
    },
    /**
     * 決済トークン更新
     * @return {[type]}
     */
    async settlementTokenUpdate() {
      this.init = this.storageGet('*');
      if (!this.init.login_flg) {
        return true
      }

      var settlementParams = {
        'sid': this.init.sid,
        'service_cd': this.init.service_cd,
        'refresh_token': this.init.refresh_token,
      };
      var update = await this.apiCall('update-settlement-token', settlementParams, 'post', 2);
      if (!update || !update.refresh_token) {
        return false
      } else {
        this.storageSave(JSON.stringify({
          'refresh_token': update.refresh_token,
          'settlement_token': update.settlement_token,
          'bkup_refresh_token': this.storageGet('refresh_token')
        }));
      }

      return true
    }
  }
}
